__turbopack_context__.v({
  "backgroundColorDesktop": "styledContainer-module-scss-module__XK_aBa__backgroundColorDesktop",
  "backgroundColorMobile": "styledContainer-module-scss-module__XK_aBa__backgroundColorMobile",
  "backgroundGradient": "styledContainer-module-scss-module__XK_aBa__backgroundGradient",
  "backgroundImage": "styledContainer-module-scss-module__XK_aBa__backgroundImage",
  "backgroundImageEffect": "styledContainer-module-scss-module__XK_aBa__backgroundImageEffect",
  "navPadding": "styledContainer-module-scss-module__XK_aBa__navPadding",
  "responsiveImage": "styledContainer-module-scss-module__XK_aBa__responsiveImage",
  "styledContainer": "styledContainer-module-scss-module__XK_aBa__styledContainer",
  "text-center": "styledContainer-module-scss-module__XK_aBa__text-center",
  "text-justify": "styledContainer-module-scss-module__XK_aBa__text-justify",
  "text-left": "styledContainer-module-scss-module__XK_aBa__text-left",
  "text-right": "styledContainer-module-scss-module__XK_aBa__text-right",
});
